<script>
	import Time from './components/Time.svelte';
	import TimeSkeleton from './components/TimeLoad.svelte';

	let tunisia_tunis, turkey_istanbul;
	let imsak = {
		istanbul: null,
		tunis: null
	}
	let maghrib = {
		istanbul: null,
		tunis: null
	}

	async function getData(city, country) {
		let fetch_data;
		const currentDate = new Date();
		const day = currentDate.getDate();
		const month = currentDate.getMonth() + 1;
		const year = currentDate.getFullYear();
		const formattedDate = `${day}-${month}-${year}`;
		await fetch(`https://api.aladhan.com/v1/timingsByCity/${formattedDate}?city=${city}&country=${country}`)
			.then(response => response.json())
			.then(data => fetch_data = data)
			.catch(error => console.error(error));
		return fetch_data;
	}
	
	document.addEventListener('DOMContentLoaded', async () => {
		tunisia_tunis = await getData("Tunis", "Tunisia");
		turkey_istanbul = await getData("Istanbul", "Turkey");
		imsak.istanbul = turkey_istanbul.data.timings.Imsak;
		maghrib.istanbul = turkey_istanbul.data.timings.Maghrib;
		imsak.tunis = tunisia_tunis.data.timings.Imsak;
		maghrib.tunis = tunisia_tunis.data.timings.Maghrib;
	});
</script>


<main class="bg-gray-300 bg-[url('/bg.jpg')] bg-cover bg-no-repeat w-screen h-screen text-white select-none">
	<div class="w-screen h-screen flex flex-col justify-center items-center">
		<p class="text-4xl font-bold drop-shadow-xl mt-0 sm:mt-4 mb-2">Ramadhan Times</p>
		<div class="block md:grid lg:grid lg:grid-cols-2">
			{#if imsak.tunis && imsak.istanbul && maghrib.tunis && maghrib.istanbul}
			<div class="mx-0 lg:mx-2 md:mx-2">
				<Time location="Tunis, Tunisia" type="Imsak" time={imsak.tunis}/>
				<Time location="Tunis, Tunisia" type="Maghrib" time={maghrib.tunis}/>
			</div>
			<div class="mx-0 lg:mx-2 md:mx-2">
				<Time location="Istanbul, Turkey" type="Imsak" time={imsak.istanbul}/>
				<Time location="Istanbul, Turkey" type="Maghrib" time={maghrib.istanbul}/>
			</div>
			{:else}
			<div class="mx-0 lg:mx-2 md:mx-2">
				<TimeSkeleton/>
				<TimeSkeleton/>
			</div>
			<div class="mx-0 lg:mx-2 md:mx-2">
				<TimeSkeleton/>
				<TimeSkeleton/>
			</div>
			{/if}
		</div>
		<p class="text-white hidden lg:block md:block">
			<kbd class="px-2 py-1.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg">Ctrl</kbd> + <kbd class="px-2 py-1.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg">D</kbd> to bookmark this page.
		</p>
	</div>
</main>